import { useEffect } from "react";
import { useMap } from "react-leaflet";

export function LeafletInteractionHandler() {
  const map = useMap();

  useEffect(() => {
    const handleInteraction = () => {
      window.dispatchEvent(new CustomEvent('leafletInteraction'));
    };

    // Escutar eventos de interação do Leaflet
    map.on('click', handleInteraction);
    map.on('dragstart', handleInteraction);
    map.on('zoomstart', handleInteraction);
    map.on('touchstart', handleInteraction);

    return () => {
      map.off('click', handleInteraction);
      map.off('dragstart', handleInteraction);
      map.off('zoomstart', handleInteraction);
      map.off('touchstart', handleInteraction);
    };
  }, [map]);

  return null;
}

